import useCurrentLoginStore from "stores/LoginStore";

import shallow from "zustand/shallow";

export const useBuildLoginInfo = () => {
	const {
		ID,
		firstName,
		lastName,
		email,
		dealerLoginID,
		companyName,
		middleName,
		title,
		commissionPercent,
		commissionFixedAmount,
		commissionType,
		commissionMinimum,
		personnelType,
		driversLicense,
		cellPhone,
		phone,
		salesLicense,
		street,
		city,
		zip,
		state,
		isHidden,
		active,
		activeDate,
		inactiveDate,
		lastLoginDate,
		profilePicture,
		username,
		isMfaActivated,
		userPrivileges,
		messagingNumber,
		locationAddress,
		locationUnit,
		locationCity,
		locationCountry,
		locationDateInactive,
		locationDealerNum,
		locationExpirationDate,
		locationFax,
		locationPhone,
		locationState,
		locationUpdatedBy,
		locationUpdatedDate,
		locationZipCode,
		locationID,
		locationCellphone,
		locationFirstName,
		locationLastName,
		locationEmail,
		locationCloudUserCount,
		dealerID,
		dealerCompanyName,
		dealerSignUpDate,
		dealerActive,
		dealerUpdatedBy,
		dealerUpdatedDate,
		dealerResellerLoginID,
		dealerWebsite,
		dealerDateInactive,
		dealerLogoUrl,
		dealerDeactiveReason,
		dealerDealerZip,
		dealerDealerType,
		dealerBillable,
		dealerCcOnFile,
		dealerAutomatedBilling,
		dealerDealerToDealerOnly,
	} = useCurrentLoginStore((state) => state, shallow);

	const loginInfo = {
		dcLogin: {
			ID,
			dealerID,
			locationID,
			firstName,
			lastName,
			email,
			dealerLoginID,
			companyName,
			middleName,
			title,
			commissionPercent,
			commissionFixedAmount,
			commissionType,
			commissionMinimum,
			personnelType,
			driversLicense,
			cellPhone,
			phone,
			salesLicense,
			street,
			city,
			zip,
			state,
			isHidden,
			active,
			activeDate,
			inactiveDate,
			lastLoginDate,
			username,
			isMfaActivated,
			userPrivileges: JSON.stringify(userPrivileges) || "",
		},
		locations: {
			ID: locationID,
			address: locationAddress,
			unit: locationUnit,
			city: locationCity,
			country: locationCountry,
			dateInactive: locationDateInactive,
			dealerNum: locationDealerNum,
			expirationDate: locationExpirationDate,
			fax: locationFax,
			phone: locationPhone,
			state: locationState,
			updatedBy: locationUpdatedBy,
			updatedDate: locationUpdatedDate,
			zipCode: locationZipCode,
			cellphone: locationCellphone,
			firstName: locationFirstName,
			lastName: locationLastName,
			email: locationEmail,
			cloudUserCount: locationCloudUserCount,
		},
		dealers: {
			ID: dealerID,
			companyName: dealerCompanyName,
			signUpDate: dealerSignUpDate,
			active: dealerActive,
			updatedBy: dealerUpdatedBy,
			updatedDate: dealerUpdatedDate,
			resellerLoginID: dealerResellerLoginID,
			website: dealerWebsite,
			dateInactive: dealerDateInactive,
			logoUrl: dealerLogoUrl,
			deactiveReason: dealerDeactiveReason,
			dealerZip: dealerDealerZip,
			dealerType: dealerDealerType,
			billable: dealerBillable,
			ccOnFile: dealerCcOnFile,
			automatedBilling: dealerAutomatedBilling,
			dealerToDealerOnly: dealerDealerToDealerOnly,
		},
		profileData: profilePicture,
		messagingNumber,
	};

	const buildLoginInfo = () => {
		return loginInfo;
	};

	return buildLoginInfo;
};

export default useBuildLoginInfo;
